/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import checkout from "./form";

const {
  formField: {
    name,
      email,
      role_id,
      location_id,
      password,
      password_confirmation
  },
} = checkout;

const initialValues = {
  [name.name]: "",
  [email.name]: "",
  [role_id.name]: -1,
  [location_id.name]: -1,
  [password.name]: "",
  [password_confirmation.name]: "",
};

export default initialValues;
